import styled from 'styled-components';

import { getColor, getSpace } from '@stylesheets/tools';

const StyledInstructions = styled.div`
  position: relative;

  .instructions__hint {
    display: flex;
    justify-content: space-between;
    background: ${getColor('lightGray')};
    border-radius: 8px;

    video {
      max-width: 115px;
      min-width: 115px;
      object-fit: cover;
      background: linear-gradient(white, white) padding-box,
        linear-gradient(90deg, #606ded 5.89%, #72f2ed 49.35%, #ceef30 88.54%) border-box;
      border-radius: 8px;
      border: 2px solid transparent;
    }

    p {
      padding: ${getSpace('xs')} ${getSpace('xxs')};
    }
  }
  a {
    text-decoration: underline !important;
  }
`;

export default StyledInstructions;
